import { useTranslation } from 'react-i18next';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { TWarehouseTaskItemRes } from 'api/swagger';
import { useGetWarehouseTaskItems } from 'api/warehouse-task/use-get-warehouse-task-items';
import { useTransformToTableData } from 'shared/hooks/use-transform-to-table-data';
import { formatDate } from 'shared/utils/time/format-date';
import { WhTaskItemControl } from 'components/wh-tasks/wh-task-items-table/components/wh-task-item-control';
import type { IWhTaskItemsTableProps } from './types';
import styles from './wh-task-items-table.module.scss';

export const WhTaskItemsTable = (props: IWhTaskItemsTableProps) => {
  const { whTaskId } = props;
  const { t } = useTranslation();

  const { data: whTaskItems, isLoading } = useGetWarehouseTaskItems(whTaskId);

  const tableData = useTransformToTableData(whTaskItems?.data ?? []);

  const columns: ColumnsType<TWarehouseTaskItemRes> = [
    {
      title: 'ID',
      dataIndex: 'compositeId',
      key: 'compositeId',
    },
    { title: t('cargo:length_label'), dataIndex: 'length', key: 'length' },
    { title: t('cargo:width_label'), dataIndex: 'width', key: 'width' },
    { title: t('cargo:height_label'), dataIndex: 'height', key: 'height' },
    {
      title: t('cargo:weight_label'),
      dataIndex: 'weight',
      key: 'weight',
      render: (weight: number | null) => weight ?? <span className={styles.red}>0</span>,
    },
    { title: t('cargo:ldm_label'), dataIndex: 'LDM', key: 'LDM' },
    { title: t('cargo:volume_label'), dataIndex: 'volume', key: 'volume' },
    {
      title: t('wh-task:picked_up_date'),
      dataIndex: 'pickedUpDate',
      key: 'pickedUpDate',
      width: 150,
      render: (pickedUpDate: string) => {
        return pickedUpDate ? formatDate(pickedUpDate) : '';
      },
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      render: (_, whTaskItem: TWarehouseTaskItemRes) => {
        return <WhTaskItemControl whTaskItem={whTaskItem} />;
      },
    },
  ];

  return (
    <Table
      className={styles.expandedTable}
      loading={isLoading}
      columns={columns}
      dataSource={tableData}
      pagination={false}
      rowClassName={(record) => (record.pickedUpDate ? styles.pickedUpRow : '')}
    />
  );
};
